import { type RefObject, useEffect } from "react";
import type { BuilderUIStore } from "../Store";

export const useClearHistoryOnPageChange = (
  store: RefObject<BuilderUIStore | undefined>,
) => {
  useEffect(() => {
    if (!store.current) return;
    return store.current.subscribe(
      state => state.currentPageId,
      () => store.current?.temporal?.getState().clear(),
    );
  }, [store]);
};
